import styles from "./topbar.module.css";
import { ArrowBack, Home } from "@mui/icons-material";
import Image from "next/image";
import { useState } from "react";
import { StoredChat } from "../../../../../../../lib/chat-store/types";
import { useChatStore } from "../../../../../../../lib/chat-store/chats-store";
import { useIsMobile } from "@/hooks/useIsMobile";
import { getResponseTimeUI } from "@/lib/get-response-time-ui";
import { useTranslations } from "next-intl";

export default function Topbar({ chatData }: { chatData: StoredChat }) {
  const [isActive, setIsActive] = useState(false);
  const setOpenChatId = useChatStore((state) => state.setOpenChatId);
  const isMobile = useIsMobile(960);
  const t = useTranslations("ChatsView");

  return (
    <div className={styles.topbarWrapper}>
      <div className={styles.mainContent}>
        {isMobile && (
          <button
            className={styles.backButton}
            onClick={() => setOpenChatId("")}
          >
            <ArrowBack />
          </button>
        )}
        <Image
          className={styles.image}
          src={chatData.receiver_photo_url || "/broken_image.webp"}
          width={48}
          height={48}
          alt={`${chatData.receiver_complete_name || "User"} profile photo`}
        />
        <div className={styles.infoWrapper}>
          <h3 className={styles.username}>
            {chatData.receiver_complete_name || "Unknown User"}
          </h3>
          <div className={styles.infoRow}>
            {(() => {
              const { status, displayType, value } = getResponseTimeUI(
                chatData.receiver_response_time,
              );
              return (
                <div className={styles.responseTime}>
                  <div className={styles.responseDotWrapper}>
                    <span
                      className={`${styles.responseDot} ${styles[status]}`}
                    />
                  </div>
                  <span className={styles.responseContent}>
                    {t(status)} {value} {t(displayType)}
                  </span>
                </div>
              );
            })()}
          </div>
        </div>
      </div>
      {isActive && (
        <div className={styles.cardWrapper}>
          {/* <ListingCard onDeactivateClick={() => setIsActive(false)} /> */}
        </div>
      )}
    </div>
  );
}
